jQuery(document).ready(function($)  {

//alert("test");

/*
var navItems = new Array();

$('section.navigable').each(function(){
  var navItemName = $(this).attr('data-title');
  console.log(navItemName);
  var navItemId = navItemName.replace(/\s+/g, '-').toLowerCase(); 
  $(this).attr("id", navItemId);
  navItems.push({ id: navItemId, name: navItemName });
});


$.each(navItems, function(index, value) {
  $('<a />', {
    'text': value.name,
    'href': "#"+value.id
    //'href': id
  }).appendTo('#sub-nav');
});
*/

$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
});


    $('.toggle').click(function(){
        $(this).toggleClass('on');
        //$('body').toggleClass('no-scroll');
        $('.menu-wrapper').toggleClass('on');
    }); 

   /* $('.contact-open').click(function(){
        event.preventDefault();
        $('.contact-panel').addClass('on');
    });

    $('.contact-close').click(function(){
        event.preventDefault();
        $('.contact-panel').removeClass('on');
    });
*/

  $('.page-scroll').click(function(){
      $('html, body').animate({
          scrollTop: $( $.attr(this, 'href') ).offset().top
      }, 1000);
      return false;
  });




$('.accordion-toggle').click(function(e) {
    e.preventDefault();
    var $this = $(this);

    $(this).toggleClass('active');
    $('.accordion-toggle').not(this).removeClass('active');
    

    if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
        $this.next().slideUp(350);
    } else {
        $this.parent().parent().find('li .inner').removeClass('show');
        $this.parent().parent().find('li .inner').slideUp(350);
        $this.next().toggleClass('show');
        $this.next().slideToggle(350);
    }
});


if ( $('.swiper').length && window.Swiper ) {
  const SwiperClass = window.Swiper;
  $('.swiper').each(function () {
   // alert("swiper init");
    new SwiperClass(this, {
      slidesPerView: 1,
      spaceBetween: 20,
    slidesOffsetBefore: 20,
    slidesOffsetAfter: 20,
    centeredSlides: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,

      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: false
        }
      } 
    });
  });
}

gsap.to(".header-image", {
  opacity: 0,
  ease: "none",
  scrollTrigger: {
    trigger: ".header-image",
    start: "top top",
    endTrigger: ".header-content",
    end: "bottom top",
    scrub: 2,
  },
});

});



window.initAcfMaps = function() {
    const maps = document.querySelectorAll( '.acf-map' );
    if ( ! maps.length ) return;

    maps.forEach( function( el ) {
        const lat  = parseFloat( el.dataset.lat );
        const lng  = parseFloat( el.dataset.lng );
        const zoom = parseInt( el.dataset.zoom ) || 17;

        gsap.set( el, { opacity: 0 });

        const map = new google.maps.Map( el, {
            center: { lat, lng },
            zoom: zoom,
            styles: themeMapData.styles,
            disableDefaultUI: true,
            gestureHandling: 'auto',
            zoomControl: true,
            scrollwheel: true,
            draggable: true,
            keyboardShortcuts: false,
        });

        google.maps.event.addListenerOnce( map, 'tilesloaded', function() {
            gsap.to( el, {
                opacity: 1,
                duration: 1,
                ease: 'power2.out'
            });
        });

        new google.maps.Marker({
            position: { lat, lng },
            map: map,
            icon: {
                path: google.maps.SymbolPath.CIRCLE,
                fillColor: '#a300b1',
                fillOpacity: 0.9,
                strokeWeight: 0,
                scale: 20,
            }
        });
    });
};


